import { styled, Typography } from "@mui/material";
import { StyledInputBase as InputBase } from "components/Input/styled";
import { Field } from "formik";

const FrameChildContainer = styled("div")(({ theme }) => ({
  padding: "12px",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, 20%)",
  gridGap: "2.5%",
  justifyContent: "space-between",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: "100%",
  height: "40px",
}));
const ElementContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "70px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const InputElement = ({ title, name }: { title: string; name: string }) => {
  return (
    <ElementContainer>
      <Typography variant="caption">{title}</Typography>
      <Field name={name} as={StyledInputBase} placeholder="px" type="number" />
    </ElementContainer>
  );
};
const FrameChild = () => {
  return (
    <FrameChildContainer>
      <InputElement title="بالا" name="paddingTop" />
      <InputElement title="راست" name="paddingRight" />
      <InputElement title="پایین" name="paddingBottom" />
      <InputElement title="چپ" name="paddingLeft" />
    </FrameChildContainer>
  );
};

export default FrameChild;
